import { useQuery } from '@tanstack/react-query';
import { getPosIntegrationDataApi } from '../utils/apis';
import { useUser } from './useUser';

export const usePosIntegrationData = () => {
  const { user } = useUser();
  const { data, isLoading } = useQuery({
    queryKey: ['pos-integration-data'],
    queryFn: () => getPosIntegrationDataApi(user?.tenantName),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: !!user?.tenantName,
  });

  return { data, isLoading };
};
